import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { NormalizedUIField } from '../../../store/config.models';

@Component({
    selector: 'app-image-element',
    templateUrl: './image-element.component.html',
    styleUrls: ['./image-element.component.scss'],
})
export class ImageElementComponent {
    @Input() field: NormalizedUIField;
    @Input() isReadOnly = false;

    constructor(private store: Store, private translate: TranslateService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    /**
     * Handles image click actions by dispatching any configured events
     */
    onImageAction(event: Event): void {
        if (this.field.events?.onClick && !this.field.disabled && !this.isReadOnly) {
            this.field.events.onClick(event).forEach((action) => this.store.dispatch(action));
        }
    }
}
